<template>
  <div class="id-validate data-validate my-files">
    <div class="validate-top">
      <div class="top-left">
        <span class="title">{{$t('User.bankCardInfo')}}</span>
        <div class="currencyDisplay">
          <span class="currencyType">{{$t('User.account_currency')}}</span>
          <span class="currencyName">{{bankInfo.payDetailMap && bankInfo.payDetailMap.currency || '-'}}</span>
        </div>
        <span
          v-if="statusFlag"
          :style="tagStyle"
          class="tag-box-id-validate"
        >{{tagText}}</span>
      </div>
      <div
        v-if="operationFlag"
        class="edit-btn">
        <el-button
          v-if="bingFlag"
          @click="bindHandle"
        >{{$t('bind')}}</el-button>
        <el-button
          class="pointer"
          v-if="reBindFlag"
          @click="bindHandle"
        >{{$t('User.reBind')}}</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col
        :sm="12"
        :xs="24"
        class="right-col mobileCurrency"
      >
        <div class="data-line">
          <span class="text-box">{{$t('User.account_currency')}}</span>
          <span class="data-box">{{bankInfo.payDetailMap && bankInfo.payDetailMap.currency || '-'}}</span>
        </div>
      </el-col>
      <el-col
        :sm="12"
        :xs="24"
        class="right-col"
      >
        <div class="data-line">
          <span class="text-box">{{$t('Recipient_bank_account_number')}}</span>
          <span class="data-box">{{bankInfo.payDetailMap && bankInfo.payDetailMap.bankAccount || '-'}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">{{$t('User.bankOutlet')}}</span>
          <span class="data-box">{{bankInfo.payDetailMap && bankInfo.payDetailMap.bankOutlet || '-'}}</span>
        </div>
      </el-col>
      <el-col
        :sm="12"
        :xs="24"
        class="left-box"
      >
        <div class="data-line">
          <span class="text-box">{{$t('Beneficiary_bank_name')}}</span>
          <span class="data-box">{{bankInfo.payDetailMap && bankInfo.payDetailMap.bankName || '-'}}</span>
        </div>
        <div class="data-line">
          <span class="text-box">SwiftCode</span>
          <span class="data-box">{{bankInfo.payDetailMap && bankInfo.payDetailMap.swiftCode || '-'}}</span>
        </div>
      </el-col>
    </el-row>
    <bank-info-edit-dialog
      :dialog-show="dialogShow"
      @close="closeHandel"
      @ajax-success="editSuccess"
    ></bank-info-edit-dialog>
  </div>
</template>

<script>
import bankInfoEditDialog from "@/components/myFiles/collection/bankInfoEditDialog";
import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
export default {
  name: "localRemittance",
  components:{
    bankInfoEditDialog
  },
  props: {
    bankInfo: {
      type: Object,
      default(){
        return {
          examineStatus: '',
          payDetailMap: {
            bankName: '',
          }
        }
      },
    },
  },
  data() {
    return {
      yellowColor: '#F29132',
      greenColor: '#41B883',
      redColor: '#D85E5F',
      countryList:[],
      dialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    operationFlag(){
      if(this.userInfo.auditStatus == 4){
        return true;
      }else {
        return false;
      }
    },
    reBindFlag(){
      if(this.userInfo.custStatus == 10){
        return false;
      }
      return this.bankInfo.examineStatus==3 || this.bankInfo.examineStatus==2;
    },
    bingFlag(){
      if(this.bankInfo.examineStatus === 0 || this.bankInfo.examineStatus === null){
        return true;
      }else {
        return false;
      }
    },
    /*backTip() {
      switch (this.bankInfo.examineStatus) {
        case 0:
        case null:
          return this.$t('bind');
        case 1:
          return '';
        case 2:
          return this.$t('User.custStatus4');
        case 3:
          return this.$t('User.authPass');
      }
    },*/
    tagText() {
      switch (this.bankInfo.examineStatus) {
        case 0:
        case null:
          return ''; // 未填写
        case 1:
          return this.$t('User.authing');
        case 2:
          return this.$t('User.custStatus4');
        case 3:
          return this.$t('User.authPass');
      }
    },
    editFlag(){
      if(this.userInfo.auditStatus == 4){
        return false;
      }else {
        return true;
      }
    },
    statusFlag(){
      if(!this.bankInfo.examineStatus){
        return false;
      }else {
        return true;
      }
    },
    tagStyle(){
      if(this.bankInfo.examineStatus == 2){
        return {
          backgroundColor: colorRgba(this.redColor,.1),
          color: this.redColor,
        }
      }else if(this.bankInfo.examineStatus == 3){
        return {
          backgroundColor: colorRgba(this.greenColor,.1),
          color: this.greenColor,
        }
      }else if(this.bankInfo.examineStatus == 1){
        return {
          backgroundColor: colorRgba(this.yellowColor,.1),
          color: this.yellowColor,
        };
      }
    },
  },
  created() {
    
  },
  methods: {
    bindHandle(){
      this.dialogShow = true;
    },
    closeHandel(){
      this.dialogShow = false;
    },
    editSuccess(){
      this.dialogShow = false;
      this.$emit('ajax-success');
    }
  },
}
</script>

<style lang="scss" >
.id-validate.my-files {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  .validate-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #5E5873;
      white-space: nowrap;
    }
  }
  .tag-box-id-validate {
    border-radius: 15px;
    font-size: 12px;
    width: 68px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    display: inline-block;
    margin-left: 10px;
  }
  .edit-btn {
  }
  .left-box {
    .data-line {
      margin-bottom: 10px;
      .text-box {
        text-align: right;
        color: #A29FAE;
        font-size: 14px;
      }
      .data-box {
        text-align: left;
        color: #5E5873;
        font-size: 14px;
      }
    }
  }
  .right-col {
    .data-line {
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .text-box {
      text-align: right;
      color: #A29FAE;
    }
  }
}
.mobileCurrency{
    display: none;
}
// 移动端
@media screen and (max-width: 768px){
  .currencyDisplay{
     display: none;
  }
  .mobileCurrency{
    display: block;
  }
}


.currencyDisplay{
  margin-left: 12px;
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 12px;
  .currencyType{
      padding: 0px 6px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      text-align: center;
      background-color: #F3F2F7;
      border: 1px solid #F3F2F7;
      float: left;
  }
  .currencyName{
      width: 50px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      text-align: center;
      border: 1px solid #E5E5E5;
      border-radius: 0px 12px 12px 0px;
      box-sizing: border-box;
      float: left;
  }
}
</style>
